import { useAppScopeStore } from '@frontend/scope';
import { PaymentSettingsGroup } from '../atoms/payment-settings-group';
import { PaymentSettingsCard } from '../atoms/payments-card';
import { PaymentMethods } from '../sections/payment-methods';

export const PaymentMethodsGroup = () => {
  const { selectedLocationIds: locationIds } = useAppScopeStore();
  return (
    <section>
      {locationIds.length === 1 ? (
        <PaymentSettingsCard locationId={locationIds[0]}>
          <PaymentMethods />
        </PaymentSettingsCard>
      ) : (
        <PaymentSettingsGroup showManageAllToggle>
          <PaymentMethods />
        </PaymentSettingsGroup>
      )}
    </section>
  );
};
